/* eslint-disable import/prefer-default-export */
export const hostname = {
  heid: 'heid.sachso.edu.vn',
  phuongnam: 'sachso.edu.vn',
  local: 'localhost',
};

// rẻ nhánh khi gặp tên miền heid
export const isNotHeid = window.location.hostname !== hostname.heid;

export const studentUnitExercise = window.location.pathname.includes('lms/exercise');
